/** Renders a Work cover with a deterministic title-based fallback. */
import type { WorkCover as WorkCoverValue } from "@loomua/contracts";

export function WorkCover({
  cover,
  title,
  className = ""
}: {
  cover: WorkCoverValue;
  title: string;
  className?: string;
}) {
  if (cover) {
    return (
      <img
        className={`work-cover ${className}`.trim()}
        src={cover.url}
        width={cover.width ?? undefined}
        height={cover.height ?? undefined}
        alt={cover.alt}
      />
    );
  }
  return (
    <div
      className={`work-cover work-cover-default ${className}`.trim()}
      role="img"
      aria-label={`${title} cover`}
    >
      <span>{title.slice(0, 1).toLocaleUpperCase()}</span>
    </div>
  );
}
